import React from 'react';
import './Header.css';

const Header = () => {
    return (
        // Header Section of The Site
        <div className="header" > <br />
            <h1> The Writers Club </h1>
            <h4>"A writer is someone for whom writing is more difficult than it is for other people." </h4>
            <br />
            <h1>Total Budget : 500 Million</h1>
        </div>
    );
};

export default Header;